import _ from 'underscore';
import React, { useMemo, useCallback, useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { ResponsiveStepList } from '@bingads-webui-react/step-progress-indicator';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import {
  useWizardService,
  getCurrentStepId,
  getCurrentFlow,
  WIZARD_EVENTS,
} from '@bingads-webui-react/wizard';

import { getStepListConfig } from './step-config';

export const StepList = () => {
  const { state, send } = useWizardService();
  const i18n = useContext(I18nContext);

  const currentStepId = getCurrentStepId(state);
  const currentFlow = getCurrentFlow(state);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const { flow, createScenario } = state.context.wizardData;

  const stepListConfig = useMemo(() => getStepListConfig({
    i18n, flow, currentStepId, createScenario,
  }), [currentStepId, flow, i18n, createScenario]);

  const getDefaultOnItemClickFn = useCallback((step) => {
    let toStep;
    if (currentFlow.includes(step.id)) {
      toStep = step;
    } else if (!_.isEmpty(step.steps)) {
      const firstSubStep = _.find(step.steps, s => currentFlow.includes(s.id));
      if (firstSubStep) {
        toStep = firstSubStep;
      }
    }
    if (toStep && toStep.isBehind) {
      return () => {
        send(WIZARD_EVENTS.NAVIGATE_TO, {
          stepId: toStep.id,
        });
      };
    }
    return undefined;
  }, [currentFlow, send]);

  return (
    <ResponsiveStepList
      config={stepListConfig}
      currentStepId={currentStepId}
      currentFlow={currentFlow}
      getOnItemClickFn={getDefaultOnItemClickFn}
      displayMode={displayMode}
    />
  );
};

